import ContactMain from './components/ContactMain/ContactMain';
import SideBar from './components/SideBar/SideBar';

import './App.scss';

function App() {
  return (
    <div className='App'>
      <SideBar />
      <ContactMain />
    </div>
  );
}

export default App;
